import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { ToastService2 } from 'src/app/core/toast2.service';
import { ClienteapiService } from 'src/app/dao/api_cliente.service';
import { GlobalService } from 'src/app/dao/global.service';
import { User } from 'src/app/model/user';

@Component({
  selector: 'app-esqueceu-senha',
  templateUrl: './esqueceu-senha.page.html',
  styleUrls: ['./esqueceu-senha.page.scss'],
})
export class EsqueceuSenhaPage implements OnInit {

  constructor(private menu: MenuController,
    private router: Router,
    private toast: ToastService2,
    private apicliente: ClienteapiService,
    public global: GlobalService) { }

isTextFieldType: boolean;
usuarioLogado: User;
usuarioForm: string;


ngOnInit() {
this.usuarioLogado = new User();
}

ionViewDidEnter() {
this.menu.enable(false);
}

ionViewWillLeave() {
this.menu.enable(true);
}

voltar(){
  this.router.navigate(['/login']);
}




delay(ms: number): Promise<boolean> {
return new Promise(resolve => {
setTimeout(() => {
resolve(true);
}, ms);
});
}

esqueceuSenha(){
this.router.navigate(['/esqueceu-senha']);
}



async recuperar() {
try {
this.apicliente.recuperarSenha(this.usuarioForm).then(res => {
if(res[0] === null){
  this.toast.showError(res[1]);
}else{
this.toast.showSucess('Você receberá um email com as instruções de recuperação de senha!');
}
}).catch(async err => {
console.log('err', err);
this.toast.showError('Ocorreu um erro');
});


} catch (error) {
console.log(error);
this.toast.showError('Ocorreu um erro');
}

}



}


